var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h1',{staticClass:"page-header"},[_vm._v("\n      "+_vm._s(_vm.$t('question.pageTitle'))+"\n    ")]),_c('ts-breadcrumb',{attrs:{"items":[
        { text: _vm.$t('toHomePage'), href: '/' },
        {
          text: _vm.$t('question.pageTitle'),
          active: true
        }
      ]}})],1),(_vm.isStaff)?_c('staff-question'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }